import { applyMiddleware, legacy_createStore as createStore } from "redux"
import createSagaMiddleware from "redux-saga"
import { thunk as thunkMiddleware } from "redux-thunk"

import { rootReducer } from "./reducers/root.reducer"
import { rootSagas } from "./sagas/root.sagas"

const sagaMiddleware = createSagaMiddleware()

const storeConfigurator = (initialState: any) => {
    return createStore(
        rootReducer,
        initialState,
        applyMiddleware(thunkMiddleware, sagaMiddleware),
    )
}

export const appStore = storeConfigurator({})

sagaMiddleware.run(rootSagas)
